<template>
    <div id="assignModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="searchTitle" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Link Document with Claim</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <inbox-assign-general v-if="page === 0" v-bind:documentType.sync="documentType" v-bind:description.sync="description" v-bind:associationType.sync="associationType"></inbox-assign-general>
                    <inbox-assign-claims v-else-if="page === 1" v-bind:clientId="clientId" v-bind:claim.sync="claim"></inbox-assign-claims>
                    <inbox-assign-documents v-else-if="page === 2" v-bind:claimId="claim ? claim.id : null" v-bind:documentTypeId="documentType ? documentType.id : null" @selected="updateDocumentAssociations"></inbox-assign-documents>
                    <inbox-assign-confirmation v-else-if="page === 3" v-bind:documentType="documentType" v-bind:description="description" v-bind:claim="claim" :document-associations="documentAssociations"></inbox-assign-confirmation>
                </div>
                <div class="modal-footer">
                    <button v-if="page > 0" class="btn btn-secondary" @click="previous()"><i class="fas fa-chevron-left fa-xs chev-pos"></i><i class="fas fa-chevron-left fa-xs mr-1 chev-pos"></i>Previous</button>
                    <button v-if="page < lastPage" class="btn btn-secondary" @click="next()" :disabled="disableNextButton">Next<i class="fas fa-chevron-right fa-xs ml-2 chev-pos"></i><i class="fas fa-chevron-right fa-xs chev-pos"></i></button>                      
                    <button v-if="page === lastPage" class="btn btn-primary" @click="assign()" :disabled="disableAssignButton">Assign</button>
                </div>                                     
            </div>
        </div>
    </div>     
</template>

<script>
    import InboxAssignGeneral from './InboxAssignGeneralComponent.vue';
    import InboxAssignClaims from './InboxAssignClaimsComponent.vue';
    import InboxAssignDocuments from './InboxAssignDocumentsComponent.vue';
    import InboxAssignConfirmation from './InboxAssignConfirmationComponent.vue';
    import { DocumentType, AssociationType } from '../../constants.js';

    export default {
        components: {
            InboxAssignGeneral,
            InboxAssignClaims,
            InboxAssignDocuments,
            InboxAssignConfirmation
        },   
        data() {
            return {
                page: 0,
                firstPage: 0,
                lastPage: 3,
                documentId: null,
                clientId: null,
                documentType: null,
                description:  null,
                associationType: AssociationType.DOCUMENT,
                claim: null,
                documentAssociations: [],
                
                // import constants into the template
                DocumentType: DocumentType,
                AssociationType: AssociationType              
            }
        },
        computed: {
            disableNextButton: function () {
                return ((this.page == 0 && this.documentType === null) ||
                        (this.page == 1 && this.claim === null) ||
                        (this.page == 0 && this.documentType && this.documentType.id == DocumentType.OTHER && this.associationType === null));
            },
            disableAssignButton: function () {
                return (this.page == this.lastPage && (this.associationType === null || (this.associationType == AssociationType.DOCUMENT && this.documentAssociations.length < 1)));
            }
        },
        methods: {
            show: function(data) {
                this.documentId = data.documentId;
                this.clientId = data.clientId;
                this.reset();
                $('#assignModal').modal('show');
            },
            hide: function () {
                $('#assignModal').modal('hide');
            },
            reset: function () {
                this.documentType = null;
                this.description =  null;
                this.associationType = AssociationType.DOCUMENT;
                this.claim = null;
                this.documentAssociations = [];
                this.page = 0;
            },
            next: function() {
                // if associating with claim then skip document selection page
                if (this.associationType && this.associationType == AssociationType.CLAIM && this.page == 1) {
                    this.page += 2;
                }
                else if (this.page < this.lastPage) { this.page++; }
            },
            previous: function() {
                // if associating with claim then skip document selection page
                if (this.associationType && this.associationType == AssociationType.CLAIM && this.page == this.lastPage) {
                    this.page -= 2;
                }                
                else if (this.page > this.firstPage) { this.page--; }
            },
            assign() {

                if (this.documentId && this.documentType && this.claim && 
                    (this.associationType == AssociationType.CLAIM || 
                     (this.associationType == AssociationType.DOCUMENT && this.documentAssociations.length > 0))) {                    

                    axios.post('/ajax/inbox/documents/' + this.documentId + '/assign', {
                        'document_type_id': this.documentType.id,
                        'description': this.description,
                        'claim_id': this.claim.id,
                        'document_associations': this.documentAssociations.map(e => ({ id: e.id, document_status_id: e.document_status_id }))
                    })
                    .then(response => { 
                        eventHub.$emit('inbox-refresh');
                    })
                    .catch(error => {
                        let title = error.response.data.title;
                        let message = error.response.data.message;
                        let level = error.response.data.level;
                        toastr[level](message, title, { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                    });

                    this.hide();                    
                }
            },
            updateDocumentAssociations: function (value) {
                this.documentAssociations = value;
            }
        },         
        created() {
            eventHub.$on('show-inbox-assign', this.show);
            this.reset();
        },
        beforeDestroy() {
            eventHub.$off('show-inbox-assign');
        },
        watch: {
            associationType: function (value) {
                if (value == AssociationType.CLAIM) {
                    this.documentAssociations = [];
                }
            }
        }
    }
</script>

<style scoped>

</style>


